import { render, staticRenderFns } from "./paper-required-fields-update-for-citation-popup.html?vue&type=template&id=06ea7d20&scoped=true&external"
import script from "./paper-required-fields-update-for-citation-popup.js?vue&type=script&lang=js&external"
export * from "./paper-required-fields-update-for-citation-popup.js?vue&type=script&lang=js&external"
import style0 from "./paper-required-fields-update-for-citation-popup.scss?vue&type=style&index=0&id=06ea7d20&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea7d20",
  null
  
)

export default component.exports